<template>
  <!-- Header "Messages" button → in-app chat inbox (no unread-count API exists) -->
  <div class="relative inline-block text-left">
    <router-link to="/messages" :class="buttonClass" aria-label="Messages">
      <img src="../../assets/images/message-icon.png" alt="Message Icon"
        class="mobile:w-5 mobile:h-5 laptop:w-5 laptop:h-5 object-contain">
      <!-- web (laptop+): label; below laptop: round icon button (no dot: there is no unread count for messages) -->
      <div class="mobile:hidden laptop:flex gap-1 items-center">
          <span class="whitespace-nowrap inline-block text-[14px] laptop:text-[16px]">Messages</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    buttonClass: {
      type: String,
      default: '',
    },
  },
};
</script>
